import React from 'react';
import {
  FaFileUpload,
  FaTabletAlt,
  FaFolderOpen,
  FaFilter,
} from 'react-icons/fa';
import {
  FeatureStrip,
  FeatureStripItem,
  FeatureStripIcon,
} from './Features.styles';

const Features = () => {
  return (
    <FeatureStrip>
      <FeatureStripItem>
        <FeatureStripIcon>
          <FaFileUpload />
        </FeatureStripIcon>

        <div>
          <strong>Use Existing PDFs</strong>
          <span>Start with the forms you already have.</span>
        </div>
      </FeatureStripItem>

      <FeatureStripItem>
        <FeatureStripIcon>
          <FaTabletAlt />
        </FeatureStripIcon>

        <div>
          <strong>Complete Forms Digitally</strong>
          <span>Fill them out on an iPad or laptop.</span>
        </div>
      </FeatureStripItem>

      <FeatureStripItem>
        <FeatureStripIcon>
          <FaFolderOpen />
        </FeatureStripIcon>

        <div>
          <strong>Store Completed Forms</strong>
          <span>Keep submissions easier to access.</span>
        </div>
      </FeatureStripItem>

      <FeatureStripItem>
        <FeatureStripIcon>
          <FaFilter />
        </FeatureStripIcon>

        <div>
          <strong>Filter & Query</strong>
          <span>Find the records and data you need.</span>
        </div>
      </FeatureStripItem>
    </FeatureStrip>
  );
};

export default Features;
